import request from '@/utils/request'

let GovernmentApi = {

  /*政府列表*/
  list(data) {
    return request._post('/shop/plus.government.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.government.Index/indexx', data);
},
/*添加政府*/
add(data) {
    return request._post('/shop/plus.government.Index/add', data);
},
/*修改政府*/
edit(data) {
    return request._post('/shop/plus.government.Index/edit', data);
},
/*删除政府*/
del(data) {
    return request._post('/shop/plus.government.Index/del', data);
},
/*政府详情*/
detail(data) {
  return request._post('/shop/plus.government.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.government.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.government.Setting/getSetting', data, errorback);
    },
}
export default GovernmentApi;



// WEBPACK FOOTER //
// ./src/api/government.js